<template>
    <section class="section--content-activity-list-item">
        <NestedActivityContent :items="localItems" :defaultLanguage="defaultLanguage" :lastEditedUuid="localLastEditedUuid"/>
        <button class="btn btn-matt" @click.prevent="openCreationForm">
            <i class="fas fa-plus-circle"></i> Aggiungi card
        </button>
        <ActivityItemModal :languages="languages" :defaultLanguage="defaultLanguage" :activityUuid="activityUuid" :tags="tags" :businessModels="businessModels" />
    </section>
</template>

<script>
    import EventBus from './EventBus'
    import NestedActivityContent from "./NestedActivityContent";
    import ActivityItemModal from './ActivityItemModal.vue';
    export default {
        props: [
            'displayable',
            'content',
            'tags',
            'languages',
            'defaultLanguage',
            'activityUuid',
            'lastEditedUuid',
            'businessModels'
        ],
        components: {
            NestedActivityContent,
            ActivityItemModal
        },
        data () {
            return {
                localItems: this.displayable,
                localLastEditedUuid: this.lastEditedUuid,
            }
        },

        mounted () {
            EventBus.$on('orderChanged', (payload) => this.saveOrder(payload))
            EventBus.$on('newContentAdded', () => this.pullContent())
        },

        methods: {
            saveOrder (lastMovingUuid = null) {
                window.axios.post(`/activities/${this.activityUuid}/order`, {ordered: this.ordered, lastMovingUuid: lastMovingUuid}).then((response) => {
                  this.$toasted.show('Contenuto aggiornato', {
                    icon: 'info'
                  })
                  EventBus.$emit('newContentAdded')
                })
            },

            pullContent () {
                window.axios.get(`/activities/${this.activityUuid}/as-json`).then((response) => {
                  this.localItems = response.data.items
                  this.localLastEditedUuid = response.data.lastEditedUuid
                })
            },

            openCreationForm () {
                EventBus.$emit('setCurrentEditableItem', null)
            }
        },

        computed: {
            ordered () {
                return JSON.stringify(this.localItems)
            }
        },
    }
</script>
